import { NavbarBrand, NavLink } from 'View/Component';
import Style from './SleepBrandLink.style';
import { Link } from 'react-router-dom';
import { linkHandler } from 'utils';

export const SleepBrandLink = () => (
  <Style>
    <NavbarBrand
      tag={() => (
        <NavLink className="navbar-sleep-brand p-0" tag={Link} to={linkHandler.get('home')}>
          7Schläfer Home
        </NavLink>
      )}
    >
      Logo
    </NavbarBrand>
  </Style>
);
